import React from 'react';
import SchemaOrg from './schema-org';
import { GRANTED } from '../../../general/js/api/endeavor/constants/api-constants';

export const getSchemaOrgForEndeavorVideos = (videos) => {
    return videos
        .filter((video) => video.accessLevel === GRANTED)
        .map((video) =>
            <SchemaOrg
                key={video.id}
                model={getSchemaOrgEndeavorVideoModel(video)} />);
};


export const getSchemaOrgForEndeavorVideo = (video) => {
    const schemaOrgModel = getSchemaOrgEndeavorVideoModel(video);

    return video.accessLevel === GRANTED &&
        <SchemaOrg model={schemaOrgModel} />;
};

export const getSchemaOrgEndeavorVideoModel = (video) => {
    return {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        '@id': video.id,
        name: video.title,
        description: video.description,
        thumbnailUrl: video.thumbnailUrl,
    };
};
